export default "__VITE_ASSET__RBlb5CkC__"